<ui-section [title]="config.translations.widgetTitle">
    <ui-section-actions>
        <ui-icon-button
            color="primary"
            iconName="export-spreadsheet"
            class="no-print"
            [advizeoTooltip]="'CSV_EXPORT.MOUSEHOVER' | translate"
            (click)="exportDataAsCsv()"
        />
    </ui-section-actions>
    <ui-section-content>
        <developer-helper datasourceCode="consumption" />
        @if (chartConfig.status() === 'resolved') {
            @if (chartConfig.value(); as value) {
                <highcharts-chart class="chart" [options]="value" [recreateOnUpdate]="true" />
            }
        }
        <loading-and-error [resource]="chartConfig" />
    </ui-section-content>
</ui-section>
